<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Rol</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div v-if="role" class="row">
        <div class="col-md-12 justify-content-center">
          <card class="mb-4" :no-body="true" header-classes="pb-3">
            <!-- Card header -->
            <template slot="header">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    {{ role.label }}
                  </h3>
                  <small>Editar permisos</small>
                </div>

                <div class="col text-right">
                  <base-button native-type="submit" type="primary" @click="onSave"> Guardar </base-button>
                </div>
              </div>
            </template>
          </card>

          <permission-edit
            v-if="role && permissions.length > 0"
            ref="edit"
            :permissions="permissions"
            :role="role"
            @save="save"
          >
          </permission-edit>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PermissionEdit from './Edit/PermissionEdit';
import swal from 'sweetalert2';

export default {
  name: 'RolesEdit',
  components: {
    RouteBreadCrumb,
    PermissionEdit,
  },

  data() {
    return {
      role: null,
      permissions: [],
    };
  },

  created() {
    const params = {
      include: 'permissions',
    };

    this.$services
      .resource('roles')
      .show(this.$route.params.id, params)
      .then((res) => res.data.data)
      .then((data) => (this.role = data));

    this.$services
      .resource('permissions')
      .get()
      .then((res) => res.data.data)
      .then((data) => (this.permissions = data.permissions));
  },

  methods: {
    onSave() {
      this.save(this.$refs.edit.getPermissionsToSave());
    },

    save(permissions) {
      this.$services
        .resource('roles')
        .attach(this.role.id, permissions)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'Se guardaron los permisos para el rol.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'RolesList' }));
        });
    },
  },
};
</script>
